
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.06 14.5a2 2 0 110 1H.5a.5.5 0 010-1zm5-7a2 2 0 110 1H.5a.5.5 0 010-1zm-4-6A2 2 0 117 4a2 2 0 01-1.94-1.5H.5a.5.5 0 010-1zm6.44 1a.5.5 0 010-1h7a.5.5 0 010 1zm4 6a.5.5 0 010-1h3a.5.5 0 010 1zm-5 7a.5.5 0 010-1h8a.5.5 0 010 1zM7 3a1 1 0 10-1-1 1 1 0 001 1zm4 6a1 1 0 10-1-1 1 1 0 001 1zm-5 7a1 1 0 10-1-1 1 1 0 001 1z"}})])
          )
        }
      }
    